import React from 'react';
import Skeleton from 'react-loading-skeleton';

const ConfigEditorSkeleton = () => (
  <div className="mt-4">
    <div className="island mb-4">
      <div className="d-flex justify-content-between align-items-center">
        <div><Skeleton style={{width: 250, height: 38}}/></div>
        <div className="d-flex gap-2">
          <Skeleton style={{width: 250, height: 38}}/>
          <Skeleton style={{width: 100, height: 38}}/>
        </div>
      </div>
    </div>
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex gap-2">
          <Skeleton variant="button" style={{width: 90, height: 38}}/>
          <Skeleton variant="button" style={{width: 90, height: 38}}/>
          <Skeleton variant="button" style={{width: 90, height: 38}}/>
        </div>
        <div className="d-flex gap-2">
          <Skeleton variant="button" style={{width: 90, height: 38}}/>
          <Skeleton variant="button" style={{width: 90, height: 38}}/>
          <Skeleton variant="button" style={{width: 90, height: 38}}/>
        </div>
      </div>
    </div>
    <div className="island p-3">
      <Skeleton variant="panel" style={{height: 'calc(100vh - 250px)', width: '100%'}}/>
    </div>
  </div>
);

export default ConfigEditorSkeleton;

